
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { memo } from 'react';
import cx from 'classnames';
import { Button, Text } from '../../../ui-kit';
import mediaSizes from '../../../common/constants/mediaSizes';
import '../styles/_collapsed-banner.scss';








function CollapsedBanner({
  product,
  width,
  onShow,
  className
}) {
  if (width < mediaSizes.small) {
    return (
      <div className={cx('collapsed-banner collapsed-banner--small', className)}>
        <Text className="collapsed-banner__header">{`Discover what ${product} is about!`}</Text>
        <Text link className="collapsed-banner__button--text">
          <span role="button" tabIndex={0} onClick={onShow}>
            View Now
          </span>
        </Text>
      </div>);

  }

  return (
    <div className={cx('collapsed-banner', className)}>
      <Text className="collapsed-banner__header">{`Discover what ${product} is about and how it works!`}</Text>
      <Button onClick={onShow} className="collapsed-banner__button">View Now</Button>
    </div>);

}

export default memo(CollapsedBanner);